import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiLeaguesService } from '../../../../services/leagues/api/api-leagues.service';
import { AlertsService } from '../../../../services/alerts.service';
import { UserCurrencyType } from '../../../../enums/users/user-currency-type.enum';

@Component({
  selector: 'app-league-reward-add-modal',
  templateUrl: './league-reward-add-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class LeagueRewardAddModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  leagueId: number = 0;
  rank: number = 1;
  currencyType: number = 0;
  currencyQuantity: number = 0;
  currencyTicketCost: number = 0;

  readonly currencyTypes = Object.entries(UserCurrencyType).filter(([, v]) => typeof v === 'number') as [string, number][];

  private callbackSaved?: () => void;

  constructor(private apiLeaguesService: ApiLeaguesService, private alertsService: AlertsService) {}

  show(leagueId: number, callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.leagueId = leagueId;
    this.rank = 1;
    this.currencyType = 0;
    this.currencyQuantity = 0;
    this.currencyTicketCost = 0;
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    this.apiLeaguesService.addLeagueReward(this.leagueId, this.rank, this.currencyType, this.currencyQuantity, this.currencyTicketCost).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Reward added !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error adding reward : ' + error);
      }
    );
  }
}
